import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Input, Select, DatePicker, Radio, Checkbox, Collapse, notification, Divider } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Tabs } from 'antd';
import { ProfileOutlined, ControlOutlined, AuditOutlined, ContactsOutlined } from '@ant-design/icons';


import { RecordFormWrapper } from './Style';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { Button } from '../../../components/buttons/buttons';
import { Main, BasicFormWrapper } from '../../styled';
import { empleadoCreateAction, empleadoReadAction } from '../../../redux/administracion/empleados/actionCreator';
import {
  estadosListAction, municipioListAction, empleadoEsquemasContractualesListAction, tipoEmpleadosListAction
} from '../../../redux/catalogos/actionCreator';
import { sucursalListAction } from '../../../redux/administracion/sucursales/actionCreator'
import moment from 'moment';


const { TabPane } = Tabs;
const { Panel } = Collapse;

const dateFormat = 'YYYY-MM-DD';

const EmpleadoFormView = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const catalogoEstados = useSelector(state => state.CatalogosReducer.estados);
  const catalogoMunicipios = useSelector(state => state.CatalogosReducer.municipios);
  const catalogoSucursales = useSelector(state => state.SucursalReducer.dataSelectBox);
  const catalogoEsquemasContractuales = useSelector(state => state.CatalogosReducer.empleadoEsquemasContractuales);
  const catalogoTipoEmpleados = useSelector(state => state.CatalogosReducer.tipoEmpleados);
  
  const registro = useSelector(state => state.EmpleadoReducer.record);
  const isLoading = useSelector(state => state.responseReducer.loading);
  const { id } = useParams();
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(estadosListAction());
    dispatch(sucursalListAction());
    dispatch(empleadoEsquemasContractualesListAction());
    dispatch(tipoEmpleadosListAction());

  }, []);

  useEffect(() => {
    if (id)
      dispatch(empleadoReadAction(id));
    else {
      dispatch(empleadoReadAction());
      form.resetFields();
    }
  }, [id]);

  useEffect(() => {
    if (registro.id) {
      loadCatalogoMunicipios(registro.idEstado);
      form.setFieldsValue(registro);
    } else {
      form.resetFields();
    }
  }, [form, registro]);

  const loadCatalogoMunicipios = (idEstado) => {
    if (municipioListAction) {
      dispatch(municipioListAction(idEstado));
    }
  }

  const handleSubmit = async (values) => {
    let action = 'create';
    if (id) {
      action = 'update';
    }

    const responseApi = await dispatch(empleadoCreateAction({
      ...values,
      action: action
    }));
    if (responseApi) {
      let mensaje = 'Empleado creado exitosamente';
      if (action === "update") mensaje = 'Empleado actualizado exitosamente';
      notification.success({
        message: mensaje,
      });
      form.resetFields();
      history.replace('/admin/recursos-humanos/listado');
    } else {
      notification.error({
        message: 'Error al crear empleado',
      });
    }
  };

  return (
    <>
      <PageHeader
        buttons={[
          <Button className="btn-add_new" size="default" key="1" type="primary">
            <Link to="/admin/recursos-humanos/listado">Ver todos</Link>
          </Button>,
        ]}
        ghost
        title="FICHA DEL EMPLEADO"
      />
      <Main>
        <Row gutter={15}>
          <Col xs={24}>
            <Form
              className="add-record-form"
              style={{ width: '100%' }}
              layout="horizontal"
              size="small"
              form={form}
              name="addnew"
              onFinish={handleSubmit}
            >
              <RecordFormWrapper>
                <Cards headless>
                  <Divider orientation='right' plain>DATOS GENERALES <AuditOutlined style={{ fontSize: '16px' }} /></Divider>
                  <BasicFormWrapper>
                    <Form.Item name="id" initialValue="0">
                      <Input hidden />
                    </Form.Item>
                    <Form.Item name="nombre" label="Nombre(s)" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="paterno" label="Apellido paterno" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="materno" label="Apellido materno" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="idTipoEmpleado" label="Función principal" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Select placeholder="Selecciona..." options={catalogoTipoEmpleados} notFoundContent={'Sin registros'} />
                    </Form.Item>
                    <Form.Item name="idEstatus" label="Estatus del empleado" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Radio.Group>
                        <Radio value="1">
                          Activo <small>(empleado laborando)</small>
                        </Radio>
                        <Radio value="2">
                          Suspendido <small>(empleado no laborando)</small>
                        </Radio>
                        <Radio value="3">
                          Baja <small>(contrato finalizado)</small>
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </BasicFormWrapper>
                  <Divider orientation='right' plain>ACCESO AL SISTEMA <ControlOutlined style={{ fontSize: '16px' }} /></Divider>
                  <BasicFormWrapper>
                    <Form.Item name="usuario"
                      label="Usuario para ingresar al sistema"
                      rules={[{ message: 'Campo obligatorio', required: true }]} >
                      <Input placeholder="Ej. jgarcia" />
                    </Form.Item>
                    <Form.Item name="contrasena" label="Contraseña" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="idSucursal" label="Sucursal donde labora" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Select placeholder="Selecciona..." options={catalogoSucursales} notFoundContent={'Sin registros'} />
                    </Form.Item>
                    <Form.Item name="roles" label="Modulos del sistema que puede operar">
                      <Checkbox.Group>
                        <Checkbox value="1">Administración del sistema</Checkbox> <br />
                        <Checkbox value="2">Ventas</Checkbox> <br />
                        <Checkbox value="3">Recepción</Checkbox> <br />
                        <Checkbox value="4">Dentista</Checkbox> <br />
                        <Checkbox value="5">Asistente médico</Checkbox> <br />
                        <Checkbox value="6">Finanzas</Checkbox> <br />
                        <Checkbox value="7">Contabilidad</Checkbox> <br />
                        <Checkbox value="8">Compras</Checkbox> <br />
                        <Checkbox value="9">Director de clínica</Checkbox> <br />
                      </Checkbox.Group>
                    </Form.Item>
                  </BasicFormWrapper>

                  <Divider orientation='right' plain>DATOS DE CONTACTO <ContactsOutlined style={{ fontSize: '16px' }} /></Divider>
                  <BasicFormWrapper>
                    <Form.Item name="telefono_principal" label="Teléfono principal" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="Ej. 7771234567" />
                    </Form.Item>
                    <Form.Item name="telefono_secundario" label="Teléfono secundario" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="idEstado" label="Estado" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Select placeholder="Selecciona..." options={catalogoEstados} onSelect={(e) => loadCatalogoMunicipios(e)} notFoundContent={'Sin registros'} />
                    </Form.Item>
                    <Form.Item name="idMunicipio" label="Municipio" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Select placeholder="Selecciona..." options={catalogoMunicipios} notFoundContent={'Selecciona un estado'} />
                    </Form.Item>
                    <Form.Item name="calle" label="Calle" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="numero" label="Número" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="colonia" label="Colonia" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="codigo_postal" label="Código postal" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                  </BasicFormWrapper>

                  <Divider orientation='right' plain>COMPLEMENTO EXPEDIENTE <ProfileOutlined style={{ fontSize: '16px' }} /></Divider>
                  <BasicFormWrapper>
                    <Form.Item name="idEsquemaLaboral" label="Esquema contractual" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Select placeholder="Selecciona..." options={catalogoEsquemasContractuales} notFoundContent={'Sin registros'} />
                    </Form.Item>
                    <Form.Item name="fecha_nacimiento" label="Fecha de nacimiento" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="curp" label="CURP" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="rfc" label="RFC" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="nss" label="Número Seguro Social" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>                    
                    <Form.Item name="fecha_inicio_labores" label="Fecha de inicio del contrato (yyyy-mm-dd)" rules={[{ required: false }, {
                      pattern: /^\d{4}-\d{2}-\d{2}$/,
                      message: 'Escríbe la fecha en el formato indicado',
                    },]}>
                      <Input placeholder='Ej. 2000-09-30' />
                    </Form.Item>
                    <p>Referencias personales (1 de 2)</p>
                    <Form.Item name="referencia_personal1_nombre" label="Nombre" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="referencia_personal1_telefono" label="Teléfono" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <p>Referencias personales (2 de 2)</p>
                    <Form.Item name="referencia_personal2_nombre" label="Nombre" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="referencia_personal2_telefono" label="Teléfono" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                  </BasicFormWrapper>
                  <br />
                  <div className="record-form-actions text-right">
                    <Button size="default" htmlType="Save" type="primary">
                      {isLoading ? 'Cargando...' : 'Guardar'}
                    </Button>
                  </div>
                </Cards>
              </RecordFormWrapper>
            </Form>
          </Col>
        </Row>
      </Main>
    </>
  );
};

export default EmpleadoFormView;
